export const sendAnalyticsEvent = (
  analyticsEvent: object,
  parentURL: string
) => {
  if (!window || !window.parent || !window.parent.postMessage) return;

  window.parent.postMessage(
    JSON.stringify({
      type: "ANALYTICS_EVENT",
      payload: analyticsEvent,
    }),
    parentURL
  );
};
